import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ShimmerThumbnail } from "react-shimmer-effects";
import Itemcards from "../../../components/Cards/similar-rough-country-card";

export default function Similar({ sku }) {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;

    // const selectedProduct = JSON.parse(localStorage.getItem('selectedProduct'));

    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasData, setHasData] = useState(true);

    // const item_category = selectedProduct.category;
    // const manufacturer = selectedProduct.manufacturer;


    useEffect(() => {
        const fetchSimilarProducts = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(
                    `${mainUrl}/api/rough/getSimilarRoughCountryProducts/${sku}`
                );

                setProducts(response.data.data || []);
                if (response.data.status === 500 || !response.data.data?.length) {
                    setHasData(false);
                }
            } catch (error) {
                console.error("Error fetching similar Rough Country products:", error);
                setHasData(false);
            } finally {
                setIsLoading(false);
            }
        };
        fetchSimilarProducts();
    }, [sku]);

    // useEffect(() => {
    //     const fetchSimilarProducts = async () => {
    //         setIsLoading(true);
    //         try {
    //             const response = await axios.get(
    //                 `${mainUrl}/api/rough/getSimilarRoughCountryProducts`, {
    //                 params: {
    //                     category: item_category,
    //                     manufacturer: manufacturer
    //                 }
    //             }
    //             );

    //             setProducts(response.data.data || []);
    //             if (response.data.status === 500 || !response.data.data?.length) {
    //                 setHasData(false);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching similar Rough Country products:", error);
    //             setHasData(false);
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     };

    //     fetchSimilarProducts();
    // }, [sku, item_category, manufacturer]);


    return (
        <section className="similar-products-acc">
            <div className="container">
                <div className="col-lg-12 also-bought">
                    <div className="row">
                        {hasData && (
                            <>
                                {!isLoading && products.length > 0 && (
                                    <h3 className="Simila-txt py-3">Similar Products</h3>
                                )}

                                {!isLoading && products.length > 0 ? (
                                    products.map((item, idx) => (
                                        <Itemcards data={item} key={item.sku || idx} />
                                    ))
                                ) : isLoading ? (
                                    Array.from({ length: 5 }).map((_, idx) => (
                                        <div className="col-lg-2 col-md-3 col-sm-4 col-6 customeChanges" key={idx}>
                                            <div className="card-tyr smilar-product">
                                                <div className="tyre-imge-upper">
                                                    <ShimmerThumbnail height={163} rounded />
                                                </div>
                                                <div className="cart-body">
                                                    <h6><ShimmerThumbnail height={10} rounded /></h6>
                                                    <h4><ShimmerThumbnail height={20} rounded /></h4>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}


